import * as React from 'react';
import * as PrintTemplate from 'react-print';
import { Member } from './members.types';
import { Business } from '../business/business.types';
import { DefaultMemberPictureURL } from './members.constants';
import { LOGO_HERE } from '../business/business.constants';
import Barcode from '../barcode/Barcode';

const memberCardPrintingPaper: React.CSSProperties = {
  float: 'left',
  padding: '0.5in 0.75in',
  boxSizing: 'border-box'
};

const memberCard: React.CSSProperties = {
  padding: '12px 8px 8px',
  transition: '0.3s',
  width: '3.5in',
  height: '2in',
  float: 'left',
  boxSizing: 'border-box'
};
  
const memberImage: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: '100%',
  verticalAlign: 'middle'
};

const memberImageContainer: React.CSSProperties = {
  borderStyle: 'double',  
  width: '1.2in',
  height: '1.2in',
  float: 'left',
  boxSizing: 'border-box',
  textAlign: 'center'
};

const memberInfoContainer: React.CSSProperties = {
  borderStyle: 'double',
  width: '2in',
  height: '1.2in',
  float: 'right',
  boxSizing: 'border-box'
};

const memberInfoBottomContainer: React.CSSProperties = {
  width: '100%',
  height: '50%',
  textAlign: 'center',
  boxSizing: 'border-box'
};

const businessImage: React.CSSProperties = {
  maxWidth: '100%',
  maxHeight: '100%',
  boxSizing: 'border-box'
};

const businessImageContainer: React.CSSProperties = {
  width: '0.6in',
  height: '100%',
  float: 'left',
  marginRight: '3px',
  boxSizing: 'border-box'
};

const barcodeContainer: React.CSSProperties = {
  textAlign: 'center',
  boxSizing: 'border-box'
};

type Props = {
  readonly members: Member[]
  readonly business: Business
};

type States = {

};

class MembersCardComponent extends React.Component<Props, States> {

  constructor(props: Props) {
    super(props);
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      members: nextProps.members
    });
  }

  render() {
    let printPapers: JSX.Element[] = [];
    let memberCards: JSX.Element[] = [];
    const noCacheExtraImageUrl = '?' + new Date().getTime();

    this.props.members.map((member: Member, index: number) => {
      if (memberCards.length === 10) {
        printPapers.push(
          <div style={memberCardPrintingPaper}>
            {memberCards}
          </div>
        );

        memberCards = [];
      }

      memberCards.push(
        <div key={index} style={memberCard}>
          <div style={memberImageContainer}>
            <span
              style={{
                display: 'inline-block',
                height: '100%',
                verticalAlign: 'middle',
              }}
            />
            <img
              src={(member.picUrl)
                    ? member.picUrl + noCacheExtraImageUrl
                    : DefaultMemberPictureURL[member.gender]
                  }
              style={memberImage}
            />
          </div>
          <div style={memberInfoContainer}>
            <div 
              style={{
                overflow: 'hidden',
                wordWrap: 'break-word',
                padding: '5px',
                width: '100%',
                height: '50%',
                textAlign: 'center',
                boxSizing: 'border-box'
              }}
            >
              <div style={businessImageContainer}>
                {
                  <img
                    src={this.props.business.picUrl ? this.props.business.picUrl : LOGO_HERE}
                    style={businessImage}  
                  />
                }
              </div>
              <div>{this.props.business.name}</div>
            </div>
            <div style={memberInfoBottomContainer}>
              <div>{member.firstName}</div> 
              <div>{member.lastName}</div> 
            </div>
          </div>
          <div style={barcodeContainer}>
            <Barcode
              value={member.memberId}
              format="CODE128"
              width={2}
              height={16}
              displayValue={true}
            />
          </div>
        </div>
      );
    });

    printPapers.push(
      <div style={memberCardPrintingPaper}>
        {memberCards}
      </div>
    );

    return (
      <PrintTemplate>
        {printPapers}
      </PrintTemplate>
    );
  }
  
}

export default MembersCardComponent;



// WEBPACK FOOTER //
// ./src/members/members.card.component.tsx